<template>
    <div class="form-address">
        <div class="row">
            <div class="col-md-9">
                <div class="form-group required">
                    <label :for="fieldId('address')" class="form-control-label">
                        {{ $t('addressForm.address')}}
                    </label>
                    <input type="text"
                           :id="fieldId('address')"
                           :name="fieldName('address')"
                           class="form-control"
                           required
                           v-model="address.address"
                           v-validate="'address'">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label :for="fieldId('address2')" class="form-control-label">
                        {{ $t('addressForm.apt')}}
                    </label>
                    <input type="text"
                           :id="fieldId('address2')"
                           :name="fieldName('address2')"
                           class="form-control"
                           v-model="address.address2"
                           v-validate="'address2'">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group required">
                    <label :for="fieldId('city')" class="form-control-label">
                        {{ $t('addressForm.city')}}
                    </label>
                    <input type="text"
                           :id="fieldId('city')"
                           :name="fieldName('city')"
                           required
                           class="form-control"
                           v-model="address.city"
                           v-validate="'city'">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group required">
                    <label :for="fieldId('countryCode')" class="form-control-label">
                        {{ $t('addressForm.country')}}
                    </label>
                    <select :id="fieldId('countryCode')"
                            :name="fieldName('countryCode')"
                            class="form-control custom-select"
                            v-model="address.countryCode"
                            v-validate="'countryCode'">
                        <option v-for="countryCode in countryCodeList" :value="countryCode">
                            {{ Geo.getCountryForCode(countryCode).name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group required">
                    <label :for="fieldId('regionCode')" class="form-control-label">
                        {{ regionCodeLabel }}
                    </label>
                    <select :id="fieldId('regionCode')"
                            :name="fieldName('regionCode')"
                            class="form-control custom-select"
                            required
                            v-model="address.regionCode"
                            v-validate="'regionCode'">
                        <option v-for="(region, regionCode) in regions" :value="regionCode">
                            {{ region }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group" :class="{required: postalCodeRequired}">
                    <label :for="fieldId('postalCode')" class="form-control-label">
                        {{ postalCodeLabel }}
                    </label>
                    <input type="text"
                           :id="fieldId('postalCode')"
                           :name="fieldName('postalCode')"
                           :required="postalCodeRequired"
                           maxlength="12"
                           class="form-control"
                           v-model="address.postalCode"
                           v-validate="'postalCode'">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Geo from '../../../Utils/Geo';

    export default {
        name: 'AddressForm',
        props: ['name', 'address', 'countryCodes', 'errors'],
        data() {
            return {
                countryCodeList: this.countryCodes,
                regions: {},
                regionCodeLabel: this.address.countryCode == 'US'
                    ? i18n.t('addressForm.state')
                    : i18n.t('addressForm.province'),
                postalCodeLabel: this.address.countryCode == 'US'
                    ? i18n.t('addressForm.zip')
                    : i18n.t('addressForm.postal'),
                postalCodeRequired: this.address.countryCode === 'US' || this.address.countryCode === 'CA'
            };
        },
        computed: {
            Geo() {
                return Geo;
            },
        },
        watch: {
            'address.countryCode'() {
                this.loadRegions(this.address.countryCode);
            }
        },
        methods: {
            fieldName(field) {
                return `${this.name}[${field}]`;
            },
            fieldId(field) {
                return `${this.name}_${field}`;
            },
            loadRegions(countryCode) {
                Geo.fetchCountryDetails(countryCode).then((country) => {
                    this.regions = country.regions;
                    this.address.regionCode = Object.firstKey(country.regions);
                    this.regionCodeLabel = country.regionNomenclature;
                    this.postalCodeLabel = country.postalNomenclature;
                    this.postalCodeRequired = this.address.countryCode === 'US' || this.address.countryCode === 'CA';
                });
            }
        },
        mounted() {
            if (this.address.countryCode) {
                this.loadRegions(this.address.countryCode);
            }

            if (!this.countryCodeList) {
                this.countryCodeList = Geo.getAllCountryCodes();
            }
        }
    };
</script>

<style scoped>

</style>